module.exports = __webpack_public_path__ + "img/logo_1.520055c5.png";